function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0,26.91V2A2.19,2.19,0,0,1,1.24,0L15.66,14.44,1.23,28.89A2.2,2.2,0,0,1,0,26.91ZM20.24,19,4.46,28.14,16.9,15.69Zm4.9-6.32a2.21,2.21,0,0,1,0,3.48l-3.35,1.93-3.66-3.67,3.66-3.67ZM4.47.75,20.23,9.86,16.9,13.2Z",
    style: {
      fill: "#fff"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGooglePlay);
export default __webpack_public_path__ + "static/media/icon-google-play.69e3a299188c05b7590f6a94d6744a55.svg";
export { ForwardRef as ReactComponent };